import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-white border-t py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <Link to="/" className="text-2xl font-bold text-blue-700 mb-4 inline-block">
            Uplatz Text2SQL
          </Link>
          <p className="text-gray-500 max-w-sm">
            Empowering organizations to interact with their databases using everyday language. Simplifying data access for everyone.
          </p>
        </div>

        <div>
          <h3 className="font-semibold text-slate-900 mb-4">Company</h3>
          <ul className="space-y-3">
            <li><Link to="/about-us" className="text-gray-500 hover:text-blue-600 transition-colors">About Us</Link></li>
            <li><Link to="/contact-us" className="text-gray-500 hover:text-blue-600 transition-colors">Contact Us</Link></li>
            {/* <li><Link to="/pricing" className="text-gray-500 hover:text-blue-600 transition-colors">Pricing</Link></li> */}
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-slate-900 mb-4">Information</h3>
          <ul className="space-y-3">
            <li>
              <a
                href="mailto:support@uplatz.com"
                className="text-gray-500 hover:text-blue-600 transition-colors"
              >
                support@uplatz.com
              </a>
            </li>

            <li>
              <a
                href="tel:+447459302492"
                className="text-gray-500 hover:text-blue-600 transition-colors"
              >
                +44 7459 302492
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-8 mt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
        <p>© 2025 Uplatz Text2SQL. All rights reserved.</p>
        <p>Built for Data Democratization</p>
      </div>
    </footer>
  );
}
